import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getApiBaseUrl } from '../services/api-base-url';
import { LookupResponse, PortalResponse, UserRoleResponse } from '../models/common.model';
import { LookupCode } from './lookup-codes';

@Injectable({ providedIn: 'root' })
export class LookupApiService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = getApiBaseUrl();

  // Any combination of lookup lists in one request, keyed by lookup code.
  getLookups(codes: readonly LookupCode[], includeInactive = false): Observable<Record<string, LookupResponse[]>> {
    return this.http.get<Record<string, LookupResponse[]>>(`${this.apiBaseUrl}lookups`, {
      params: { codes: codes.join(','), includeInactive },
    });
  }

  getPortals(): Observable<PortalResponse[]> {
    return this.http.get<PortalResponse[]>(`${this.apiBaseUrl}portals`);
  }

  getUserRoles(): Observable<UserRoleResponse[]> {
    return this.http.get<UserRoleResponse[]>(`${this.apiBaseUrl}user-roles`);
  }
}
